var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-input-label", [_vm._v(_vm._s(_vm.label))]),
      _c(
        "div",
        {
          staticClass: "d-flex"
        },
        [
          _vm.searchPrefix
            ? _c(
                "label",
                {
                  staticClass: "pt-2 pr-2"
                },
                [_vm._v(_vm._s(_vm.searchPrefix))]
              )
            : _vm._e(),
          _c("v-combobox", {
            staticClass: "gg-input",
            attrs: {
              outlined: "",
              dense: "",
              "hide-details": "",
              loading: _vm.loading,
              items: _vm.items,
              name: _vm.name,
              "no-filter": "",
              "error-messages": _vm.errorMessages,
              "search-input": _vm.searchVal
            },
            on: {
              "update:searchInput": function updateSearchInput($event) {
                _vm.searchVal = $event
              },
              "update:search-input": function updateSearchInput($event) {
                _vm.searchVal = $event
              }
            },
            model: {
              value: _vm.searchVal,
              callback: function callback($$v) {
                _vm.searchVal = $$v
              },
              expression: "searchVal"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }